import type { ElementType } from 'react'
import { twMerge } from 'tailwind-merge'

import { Text } from '../Text'

import { useExpandableTextContext } from './ExpandableText'
import type { ExpandableTextContentProps } from './types'

const defaultElement = 'p'

export const Content = <TElement extends ElementType = typeof defaultElement>({
  className,
  children,
  as,
  ...props
}: ExpandableTextContentProps<TElement>) => {
  const { isExpanded, textId } = useExpandableTextContext()
  const element: React.ElementType = as ?? defaultElement

  const defaultClampClass = 'line-clamp-2 md:line-clamp-1'

  const resolvedClassName = twMerge(!isExpanded && defaultClampClass, className)

  return (
    <Text id={textId} as={element} className={resolvedClassName} {...props}>
      {children}
    </Text>
  )
}
